import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, Typography } from 'seagull';
import { RelationshipEffectiveDate } from '~/components/RelationshipEffectiveDate/RelationshipEffectiveDate';
import { useLocaleKeys } from '~/i18n';
import { proposalStageAnchor } from '~/models/service/stageScheduleContext';
import { toDateStampObject } from '~/models/time';
import { useIoContext } from '~/providers/IoContext';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import styles from './Cells.module.scss';
export default function EffectiveDateCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { getNow } = useIoContext();
    const { t: cellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells.shared');
    const { t: editTableTexts } = useLocaleKeys('proposal.draftsDashboard.cells.shared');
    const onClick = ()=>onOpenModal({
            width: '400px',
            maxHeight: 'none',
            bodyClassName: styles.effectiveDateModalBody,
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                const onEffectiveDateChange = (date)=>setDraft(draft.setEffectiveDate(date == null ? null : toDateStampObject(date), proposalStageAnchor({
                        effectiveDate: date,
                        now: getNow()
                    })));
                return {
                    title: cellsTexts.effectiveDateTitle(),
                    testId: 'edit-effective-date-modal',
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(Grid, {
                        rowGap: "small",
                        children: /*#__PURE__*/ _jsx(RelationshipEffectiveDate, {
                            fullWidth: true,
                            className: styles.effectiveDate,
                            value: draft.effectiveDateAsDate(),
                            onChange: onEffectiveDateChange,
                            title: cellsTexts.effectiveDateTitle(),
                            description: cellsTexts.effectiveDateDescription()
                        })
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-effective-date-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "effective-date-".concat(index),
            children: draft.formattedEffectiveDate() || editTableTexts.onAcceptance()
        })
    });
}
